<template>
	<div class="report-left-list consultant-workload" :class="isClosed">
		<div class="each-turn customer-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i v-tooltip.top-start="relation.customerName">{{relation.customerName|truncate}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn consultant-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i v-tooltip.top-start="relation.fullName">{{relation.fullName|truncate}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn project-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i v-tooltip.top-start="relation.projectTitle">{{relation.projectTitle|truncate}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn country-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i v-tooltip.top-start="relation.country">{{relation.country|truncate}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn oe-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">{{relation.oeShortname}}</p>
			</div>
		</div>
		<div class="each-turn level-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i v-tooltip.top-start="relation.levels">{{relation.levels|truncate}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn start-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i
						v-tooltip.top-start="$options.filters.iso_to_date(relation.startDate)"
					>{{relation.startDate|iso_to_date|truncate}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn end-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i
						v-tooltip.top-start="$options.filters.iso_to_date(relation.endDate)"
					>{{relation.endDate|iso_to_date|truncate}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn hrrate-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">{{relation.hourlyRate}} €</p>
			</div>
		</div>
		<div class="each-turn timeleft-field">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td left-days-cell-i" :class="daysLeftClass">{{relation.daysLeft}}</p>
			</div>
		</div>
	</div>
</template>

<script>
    import filters from "../../../../mixins/filters";

    export default {
        name: "EngagementRelationRow",
        props: ["relation"],
        mixins: [filters],
        computed: {
            /**
             * Get the forecast metadata from store
             */
            metadata: function () {
                return this.$store.state.reports.customerEngagementMetadata;
            },
            /**
             * Find the class for days left field
             * Compare the meta data with the days left value
             */
            daysLeftClass: function () {
                let metadata = this.metadata;
                if (parseInt(this.relation.daysLeft) >= parseInt(metadata.customerEngagementReportGreen)) {
                    return "blue";
                } else if (
                    parseInt(this.relation.daysLeft) >=
                    parseInt(metadata.customerEngagementReportRed) &&
                    parseInt(this.relation.daysLeft) <
                    parseInt(metadata.customerEngagementReportGreen)
                ) {
                    return "yellow";
                } else {
                    return "red";
                }
			},
			isClosed:function(){
				if(this.relation.isClosed===true)
					return "closed-project-row"
				else
					return"open-project-row"
			}
        }
    };
</script>

<style scoped>
	/* Header cols */
	.customer-engagement {
		width: 1015px;
		min-width: 1015px;
	}

	.customer-field {
		width: 163px;
		min-width: 163px;
		padding-left: 43px;
	}

	.consultant-field {
		width: 122px;
		min-width: 122px;
	}

	.country-field {
		width: 101px;
		min-width: 101px;
	}

	.oe-field {
		width: 90px;
		min-width: 90px;
	}

	.level-field {
		width: 82px;
		min-width: 82px;
	}

	.start-field {
		width: 82px;
		min-width: 82px;
	}

	.end-field {
		width: 82px;
		min-width: 82px;
	}

	.hrrate-field {
		width: 94px;
		min-width: 94px;
	}

	.timeleft-field {
		width: 103px;
		min-width: 103px;
	}

	.project-field {
		width: 96px;
		min-width: 96px;
	}

	.timeleft-field .alloc-value {
		height: 100%;
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		justify-content: center;
		-webkit-justify-content: center;
	}

	.timeleft-field p {
		padding: 0;
	}

	.left-days-cell-i.green {
		background: #94e5dd;
		color: #099a8a;
	}

	.tv {
		width: 75px;
	}
	
	.tv{
    width: 75px;
	}
	div.closed-project-row {
		background: #fc5c6575;
	}
</style>